import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage // 选择sessionStorage作为数据存储方式
})


export default new Vuex.Store({
  strict: false,
  state,
  mutations,
  plugins: [vuexLocal.plugin] // 注册vuex-persist插件
})



// WEBPACK FOOTER //
// ./src/store/index.js